import Nav from "./components/Nav";
import Hero from "./components/Hero";
import ERPDiagram from "./components/ERPDiagram";
import Clients from "./components/Clients";
import Solutions from "./components/Solutions";
import Services from "./components/Services";
import Process from "./components/Process";
import ASYAModules from "./components/ASYAModules";
import Industries from "./components/Industries";
import Stats from "./components/Stats";
import TechStack from "./components/TechStack";
import Team from "./components/Team";
import Testimonial from "./components/Testimonial";
import WhyUs from "./components/WhyUs";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen">
      <Nav />

      <main className="pt-20">
        <Hero />
        <ERPDiagram />
        <Clients />
        <Services />
        <Process />
        <Solutions />
        <ASYAModules />
        <Industries />
        <Stats />
        <TechStack />
        <Team />
        <Testimonial />
        <WhyUs />
        <CTA />
      </main>

      <Footer />
    </div>
  );
}
